import { useState, useContext } from 'react';
import { AuthContext } from '../../../AuthContext';
import { CenterContainer, LoadingIndicator } from '../../Template';
import './login.css';
 
const LoginPage = ({ }) => {

    const { isLoading, authError, onLogin } = useContext(AuthContext);
    // TODO: remove these default values before deploying, they are only here for development convenience
    const [usernameInput, setUsernameInput] = useState('ksb_test_user');
    const [passwordInput, setPasswordInput] = useState('KSBTestUser666');

    const handleLoginClick = () => { 
        onLogin(usernameInput, passwordInput)
    }

    return (
        <div className="main-content">
            
            <h1>Editor Log In</h1>

            <div className='login-form-wrapper'> 
                <div className='login-text-input-wrapper'>
                    <label htmlFor={"username"} >Username:</label>
                    <input
                        type="text"
                        id="username"
                        value={usernameInput}
                        onChange={(e) => setUsernameInput(e.target.value)}
                        required
                        style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                    />
                </div>
                <div className='login-text-input-wrapper'>
                    <label htmlFor={"password"} >Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={passwordInput}
                        onChange={(e) => setPasswordInput(e.target.value)}
                        required
                        style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                    />
                </div>

                {authError && (<p className="login-error-msg">{authError}</p>)}

                <div className='login-button-wrapper'>
                    <button 
                        type="button" 
                        disabled={isLoading || usernameInput.trim() === '' || passwordInput.trim() === ''}
                        onClick={handleLoginClick}>
                        Sign In
                    </button>
                </div>

            </div>
            <CenterContainer>
                {isLoading && <LoadingIndicator loadingMsg={'securely logging you in...'} />}
            </CenterContainer>
        </div>
    )

}
export default LoginPage;